let firebaseApp: unknown = null
let messagingInstance: unknown = null

export async function initFirebase(): Promise<void> {
  if (firebaseApp) return

  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY as string | undefined
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined
  if (!apiKey || !projectId) return

  try {
    const { initializeApp } = await import("firebase/app")
    const config = {
      apiKey,
      authDomain: `${projectId}.firebaseapp.com`,
      projectId,
      storageBucket: `${projectId}.appspot.com`,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string ?? "",
      appId: import.meta.env.VITE_FIREBASE_APP_ID as string ?? "",
    }
    firebaseApp = initializeApp(config)
  } catch (err) {
    console.warn("Failed to initialize Firebase:", err)
  }
}

export async function requestNotificationPermission(): Promise<string | null> {
  if (!firebaseApp) await initFirebase()
  if (!firebaseApp) return null

  try {
    const permission = await Notification.requestPermission()
    if (permission !== "granted") return null

    const { getMessaging, getToken } = await import("firebase/messaging")
    messagingInstance = getMessaging(firebaseApp as import("firebase/app").FirebaseApp)
    const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY as string | undefined
    const token = await getToken(messagingInstance as import("firebase/messaging").Messaging, {
      vapidKey: vapidKey ?? undefined,
    })
    return token
  } catch (err) {
    console.warn("Failed to get FCM token:", err)
    return null
  }
}

export async function onForegroundMessage(callback: (payload: { title?: string; body?: string; data?: Record<string, string> }) => void): Promise<(() => void) | null> {
  if (!messagingInstance) return null

  try {
    const { onMessage } = await import("firebase/messaging")
    const unsubscribe = onMessage(messagingInstance as import("firebase/messaging").Messaging, (payload) => {
      callback({
        title: payload.notification?.title,
        body: payload.notification?.body,
        data: payload.data,
      })
    })
    return unsubscribe
  } catch {
    return null
  }
}
